/**
 * The welcome challenge is the gate: players must solve it before anything
 * else unlocks. It is recognised by its key, with order_index 0 as the
 * fallback the seed data also uses.
 */
export function isWelcomeChallenge(
  c: { key?: string; order_index?: number } | null | undefined
): boolean {
  return c?.key === "welcome-001" || c?.order_index === 0;
}

/**
 * Moves the welcome challenge to the front, keeping everything else in order.
 * Returns the same array when it is already first, so state setters that run
 * through it do not trigger a re-render for nothing.
 */
export function pinWelcomeFirst<T extends { key?: string; order_index?: number }>(
  list: T[]
): T[] {
  const i = list.findIndex(isWelcomeChallenge);
  if (i <= 0) return list;
  return [list[i], ...list.slice(0, i), ...list.slice(i + 1)];
}
